import React from 'react'
import styles from './InvoiceDetails.module.scss'
import Layout from '../../components/core/Layout';
import { useParams } from 'react-router-dom';
import { getTaxRate } from '../../apis/invoice-api';
import { INVOICE_TAB_INDEX, InvStatus } from '../../libs/constants';
import { InvoiceMasterData } from "../../apis/models/InvoiceMasterRequest";
import { error, success } from '../../apis/reducers/snackbarsReducer';
import { useDispatch, useSelector } from 'react-redux';
import { getInvoiceMaster, putInvoiceMaster } from '../../apis/invmaster-api';
import { TaxResponseData } from '../../apis/models/TaxResponse';
import InvoiceHeader from '../../components/InvoiceDetailsPage/header/InvoiceHeader';
import { RootState } from '../../apis/store';
import { saveMasterInfo } from '../../apis/reducers/invoiceMasterReducer';
import ArrivalInformation from '../../components/InvoiceDetailsPage/ArrivalInformation/ArrivalInformation';

const InvoiceArrivalInfoPage = () => {
  const invoiceMasterState = useSelector((state: RootState) => state.invoiceMaster);
  const dispatch = useDispatch();
  const { id } = useParams();
  const [invoiceMasterData, setInvoiceMasterData] = React.useState<InvoiceMasterData | null>(invoiceMasterState.masterData);
  const [taxItem, setTaxItem] = React.useState<TaxResponseData | null>(null);

  React.useEffect(() => {
    if (id) {
      loadAllData();
    }
  },[id])

  const loadAllData = () => {
    getInvoiceMasterData();
  }

  const onSaveAndCommit = async () => {
    onChangeInvoiceStatus(InvStatus.CONFIRMED)
  }

  const onChangeInvoiceStatus = async (status: InvStatus) => {
    try {
      await putInvoiceMaster(id!, {status: status})
      dispatch(success("請求ステータスを変更しました"));
      loadAllData();
    }catch (err) {
      dispatch(error("請求ステータスの変更に失敗しました"));
    }
  }

  const getInvoiceMasterData = () => {
    getInvoiceMaster(id)
    .then(function (response) {
        setInvoiceMasterData(response.data.data);
        dispatch(saveMasterInfo({masterData: response.data.data}))
        getTaxRate(new Date(response.data.data.from).toString())
          .then(res => setTaxItem(res.data.data))
          .catch(err => console.log(err))
    })
    .catch(function (error) {
        console.log(error);
    })
  }

  return (
    <Layout withBreadcrumbs={true} bgColor="#FAFAFA">
      <React.Fragment>
        <div className={styles.Gray}>
          <div>
            <InvoiceHeader
              invoiceMaster={invoiceMasterData ?? undefined}
              tax={taxItem ?? undefined}
              selectedTab={INVOICE_TAB_INDEX.ARRIVAL}
              needSave={false}
              error={false}
              onSaveAndCommit={() => onSaveAndCommit()}
              onChangeStatus={(status) => onChangeInvoiceStatus(status)}
              onMasterChange={() => loadAllData()}
            />
          </div>
          <div  className={styles.tabs}>
            <div className={styles.tabs__body}>
              <ArrivalInformation />
            </div>
          </div>
        </div>
      </React.Fragment>
    </Layout>
  )
}

export default InvoiceArrivalInfoPage